import { trackOnDa } from '@shaaditech/saga-deprecated/lib/tracking/tracking.helpers';

export default (source, event, uid, args = {}) => (dispatch, getState) => {
  const { metadata, session } = getState();
  trackOnDa({ source, event, uid, args, metadata, session });
};
